import { forwardRef } from 'react'
import { Form } from 'react-bootstrap'
import { FloatingLabel } from '../FloatingLabel'


const Select = forwardRef(
    ({ name, label, size = 'lg', options = [], error, ...rest }, ref) => (
        <Form.Group controlId={name}>
            <FloatingLabel label={label} size={size}>
                <Form.Select
                    name={name}
                    ref={ref}
                    isInvalid={!!error}
                    {...rest}
                >
                    <option value="">Select…</option>
                    {options.map(({ value, label }) => (
                        <option key={value} value={value}>{label}</option>
                    ))}
                </Form.Select>
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error?.message}
                    </Form.Control.Feedback>
                )}
            </FloatingLabel>
        </Form.Group>
    )
)

Select.displayName = 'Select'
export default Select
